<template>
    <modal
        :modalid="'modal_ldo'"
        :modalOpen="modalOpened"
        :profile="1"
        :form="{}"
        @close="closeModal"
    >
        <template v-slot:header>
            Políticas de Privacidade e de uso dos dados
        </template>
        <template v-slot:main>
            <div class="accordion" id="accordionExample">
                <div class="card">
                    <div class="card-header" id="headingOne">
                    <h2 class="mb-0">
                        <button class="btn btn-link btn-block text-left text-decoration-none" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        INTRODUÇÃO
                        </button>
                    </h2>
                    </div>

                    <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                    <div class="card-body text-justify">
                        O Grupo Super Safra se preocupa com a sua privacidade e por isso se compromete em proteger seus dados pessoais e as demais informações que você compartilha conosco. Por isso, a presente política tem como objetivo informar os meios que possuímos para coletar e utilizar seus dados, assim como quando e de qual forma eles poderão ser utilizados por nós. É importante a sua leitura e compreensão desta política, por isso, quaisquer dúvidas ou solicitações, entre em contato com o nosso Encarregado de Dados Pessoais (DPO) através do e-mail: <a href="mailto:dpo@supersafra.com">dpo@supersafra.com</a> ou <a href="https://novo.supersafra.com/lgpd">https://novo.supersafra.com/lgpd</a>.
                    </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header" id="headingTwo">
                    <h2 class="mb-0">
                        <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        QUAIS DADOS SÃO COLETADOS
                        </button>
                    </h2>
                    </div>
                    <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                    <div class="card-body text-justify">
                        Durante sua experiência em uma de nossas lojas podemos coletar diferentes tipos de dados pessoais, de forma automática com o objetivo de conferência, monitoramento e controle, ou fornecidas diretamente por você, como por exemplo para a realização de seu cadastro. Veja abaixo quais dados pessoais nós podemos coletar e em cada situação:
                        <ul>
                            <li>Durante o cadastro:</li>
                            <li>Nome completo;</li>
                            <li>Foto do documento de identificação(Documento de identidade; Carteira de Motorista;)</li>
                            <li>Número de CPF;</li>
                            <li>Endereço de e-mail;</li>
                            <li>Número de celular;</li>
                            <li>Data de nascimento;</li>
                            <li>Dados referentes aos seus endereços(comprovante de residência).</li>
                            <li>Endereço de cobrança;</li>
                            <li>Endereço de entrega;</li>
                            <li>Filiação.</li>
                            <li>Referencias Comerciais</li>
                            <li>Informações de renda.</li>
                            <li>Pesquisa em empresas de Análise de Crédito (Serasa, SPC, etc)</li>
                        </ul>
                    </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header" id="headingThree">
                    <h2 class="mb-0">
                        <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        COMO NÓS UTILIZAMOS OS SEUS DADOS PESSOAIS
                        </button>
                    </h2>
                    </div>
                    <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                    <div class="card-body text-justify">
                        Nós utilizamos os dados pessoais para garantir um atendimento de qualidade e uma melhor experiência na sua compra. Listamos abaixo as finalidades que poderemos utilizar seus dados pessoais:
                        <ul>
                        <li>Dados cadastrais:</li>
                        <li>Para viabilizar a prestação de serviços disponíveis em nossas lojas. </li>
                        <li>Para identificar corretamente o Cliente.</li>
                        <li>Para enviar os produtos adquiridos ou comunicações de ofertas.</li>
                        <li>Para entrar em contato com você, quando necessário. Esse contato pode contemplar diversos assuntos, como comunicação sobre promoções e ofertas, respostas a dúvidas, respostas de reclamações e solicitações, atualizações do cadastro realizado e informações de entrega.</li>
                        <li>Para desenvolver novas funcionalidades e melhorias, melhorando a sua experiência com nossos serviços disponíveis.</li>
                        <li>Para consultar suas informações nas bases de dados de agências de crédito.</li>
                        <li>Para realizar investigações e medidas de prevenção e combate a ilícitos, fraudes, crimes financeiros e crimes de lavagem de dinheiro e/ou de financiamento ao terrorismo.</li>
                        <li>Para garantir o cumprimento de obrigação legal ou regulatória ou garantir o exercício regular de direitos do Grupo Super Safra. Nesses casos, podemos, inclusive, utilizar e apresentar as informações em processos judiciais e administrativos, se necessário.</li>
                        <li>Para colaborar com o cumprimento de ordem judicial, de autoridade competente ou de órgão fiscalizador.</li>
                        </ul>
                    </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header" id="headingOne">
                    <h2 class="mb-0">
                        <button class="btn btn-link btn-block text-left text-decoration-none" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="true" aria-controls="collapseOne">
                        COM QUEM NÓS PODEMOS COMPATILHAR OS DADOS PESSOAIS
                        </button>
                    </h2>
                    </div>

                    <div id="collapseFour" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                    <div class="card-body text-justify">
                        Para a execução das atividades acima listadas, sempre que necessário, nós poderemos compartilhar os seus dados pessoais com outras empresas do nosso grupo, com prestadores de serviço, parceiros ou com órgãos reguladores. Jamais comercializamos dados pessoais. Apresentamos a seguir um resumo destas possibilidades:

                        Prestadores de serviço: para que possamos disponibilizar nossos produtos e prestar os nossos serviços com qualidade, contamos com a colaboração de diversos prestadores de serviço, que tratam os dados pessoais coletados em nosso nome e de acordo com nossas instruções. Esses prestadores de serviço atuam principalmente para nos auxiliar nas análise antifraude, intermediação de pagamentos, gestão de campanhas de marketing, enriquecimento de base de dados e armazenamento em nuvem.

                        Outras empresas do Grupo Super Safra: os seus dados pessoais podem ser compartilhados com outras empresas do Grupo Super Safra, que operam sob o mesmo nível de segurança e privacidade - assim compreendidas nossas afiliadas, coligadas, controladas e controladoras - para que possamos aprimorar os nossos serviços e soluções oferecidos aos nossos Clientes.

                        Autoridades judiciais, policiais ou governamentais: nós devemos fornecer dados pessoais de Clientes e/ou Usuários, em atendimento à ordem judicial, solicitações de autoridades administrativas, obrigação legal ou regulatória, bem como para agir de forma colaborativa com autoridades governamentais, em geral em investigações envolvendo atos ilícitos.
                    </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header" id="headingOne">
                    <h2 class="mb-0">
                        <button class="btn btn-link btn-block text-left text-decoration-none" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="true" aria-controls="collapseOne">
                        ARMAZENAMENTO E SEGURANÇA DOS DADOS PESSOAIS
                        </button>
                    </h2>
                    </div>

                    <div id="collapseFive" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                    <div class="card-body text-justify">
                        Nós armazenamos seus dados de forma segura em data centers localizados no Brasil e exterior. Neste caso de armazenamento no exterior, são adotadas todas as medidas legais aplicáveis, em conformidade com a Lei Geral de Proteção de Dados e suas futuras regulamentações, garantindo a proteção e privacidade dos seus dados pessoais.

                        Nós adotamos as melhores técnicas para proteger os dados pessoais coletados de acessos não autorizados, destruição, perda, alteração, comunicação ou qualquer forma de tratamento inadequado ou ilícito, inclusive mecanismos de criptografia. Ressaltamos, contudo, que nenhuma plataforma é completamente segura. Se você tiver qualquer preocupação ou suspeita de que os seus dados estejam em risco, por favor, entre em contato conosco por meio dos nossos canais de atendimento que ficaremos felizes em te ou auxiliar prontamente.

                        Seus dados pessoais serão mantidos durante todo o período que for um cliente ativo do Grupo Super Safra. Após esse período, podemos armazenar os seus dados pessoais por um período adicional para fins de auditoria, para possibilitar o cumprimento de obrigações legais ou regulatórias. Faremos a retenção dos seus dados pelo prazo necessário, respeitando os prazos estabelecidos na legislação aplicável.
                    </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header" id="headingOne">
                    <h2 class="mb-0">
                        <button class="btn btn-link btn-block text-left text-decoration-none" type="button" data-toggle="collapse" data-target="#collapseSix" aria-expanded="true" aria-controls="collapseOne">
                        SEUS DIREITOS COMO TITULAR DO DADOS PESSOAIS
                        </button>
                    </h2>
                    </div>

                    <div id="collapseSix" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                    <div class="card-body text-justify">
                        A transparência sobre o tratamento dos seus dados pessoais é prioridade para o Grupo Super Safra. Além das informações disponibilizadas nesta Política de Privacidade, você pode também exercer os direitos previstos na Lei Geral de Proteção de Dados, entre eles:
                        Confirmação da existência de tratamento de dados pessoais.
                        Acesso aos dados pessoais.
                        Revogação do consentimento.
                        Correção de dados pessoais incompletos, inexatos ou desatualizados.
                        Eliminação dos dados pessoais tratados com o consentimento ou desnecessários, excessivos ou quando entender que algum ponto da LGPD não foi atendido.
                        Informação sobre as hipóteses e com quais empresas do Grupo Super Safra podemos compartilhar, ou receber dados pessoais referentes a você.
                        Informação sobre a possibilidade de não fornecer consentimento e sobre as consequências da negativa, quando aplicável.
                        Todas as solicitações serão tratadas de forma gratuita, e serão submetidas a uma prévia avaliação da sua identidade e da viabilidade do atendimento, a fim de cumprir com eventuais obrigações que impeçam o completo atendimento das requisições dos titulares de direito.
                    </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header" id="headingOne">
                    <h2 class="mb-0">
                        <button class="btn btn-link btn-block text-left text-decoration-none" type="button" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="true" aria-controls="collapseOne">
                        RETENÇÃO E EXCLUSÃO DOS SEUS DADOS PESSOAIS
                        </button>
                    </h2>
                    </div>

                    <div id="collapseSeven" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                    <div class="card-body text-justify">
                        Nós trataremos seus dados pessoais com elevados níveis de proteção e garantindo sua privacidade, durante todo o período que você for nosso cliente, utilizando nossos serviços.
                        Quando aplicável, e mesmo se você optar por excluir seus dados pessoais da nossa base de cadastro, o Grupo Super Safra poderá reter alguns ou todos os seus dados pessoais por períodos adicionais para cumprimento de obrigações legais ou regulatórias, para o exercício regular de direitos do Grupo Super Safra, eventuais ações judiciais, fins de auditoria de diversas naturezas, ou outros prazos definidos e fundamentados por bases legais que justifiquem a retenção destes dados.
                    </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header" id="headingOne">
                    <h2 class="mb-0">
                        <button class="btn btn-link btn-block text-left text-decoration-none" type="button" data-toggle="collapse" data-target="#collapseEight" aria-expanded="true" aria-controls="collapseOne">
                        ALTERAÇÕES DESTA POLITICA DE PRIVACIDADE
                        </button>
                    </h2>
                    </div>

                    <div id="collapseEight" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                    <div class="card-body text-justify">
                        Estamos constantemente buscando aprimorar a experiência de nossos clientes. Assim, nossas práticas de tratamento de dados pessoais poderão sofrer alterações com a inclusão de novas funcionalidades e serviços sem aviso prévio.
                        Valorizamos a transparência no modo em que tratamos seus dados pessoais. Toda vez que alguma condição relevante desta Política de Privacidade for alterada, essas alterações serão válidas e divulgadas em nosso site. 
                    </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header" id="headingOne">
                    <h2 class="mb-0">
                        <button class="btn btn-link btn-block text-left text-decoration-none" type="button" data-toggle="collapse" data-target="#collapseNine" aria-expanded="true" aria-controls="collapseOne">
                        FALE CONOSCO
                        </button>
                    </h2>
                    </div>

                    <div id="collapseNine" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                    <div class="card-body text-justify">
                        Sempre que você tiver alguma dúvida sobre esta Política de Privacidade, mesmo após sua leitura, ou precisar interagir conosco sobre assuntos envolvendo os seus dados pessoais, poderá fazê-lo:

                        Por meio dos nossos canais de atendimento disponíveis em https://novo.supersafra.com/lgpd, solicitando as opções sobre a privacidade dos seus dados pessoais, sempre que disponível; ou Pelo e-mail do Encarregado de Dados Pessoais: <a href="mailto:dpo@supersafra.com">dpo@supersafra.com</a> 
                        Recomendamos que verifiquem a versão atualizada desta Política de Privacidade sempre que navegarem em nosso site. 
                        Estamos sempre à disposição para esclarecer suas dúvidas e colocar você no controle dos seus dados pessoais.
                        Contem conosco!
                    </div>
                    </div>
                </div>
            </div>
        </template>
        
    </modal>
</template>

<script>
    import ModalComponent from './../ModalComponent.vue';
    export default {
        data(){
            return {
                modalOpened: false,
            }
        },
        props: {
            openThis: {
                required: true
            }
        },
        methods:{
            openModal(){
                this.modalOpened = true;
            },
            closeModal(){
                this.modalOpened = false;
            }
        },
        watch: {
            'openThis': function(){
                this.openModal();
            }
        },
        components: {
            'modal': ModalComponent,
        }
    }
</script>
